import { Injectable } from '@angular/core';
import { ActivityLogSearchCriteria } from '../models/activity-log-search-criteria';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';
import { applicationUrls } from 'src/app/shared/application-constants/application-urls.const';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StpActivityLogStorageService {
  constructor(private httpClient: HttpClient) {}

  readSTPActivityLog(
      activityLogSearchCriteria: ActivityLogSearchCriteria
    ): Observable<ServerResponse> {
      return this.httpClient.post<ServerResponse>(
        `${applicationUrls.activityLog.stpActivityLog}`,
        activityLogSearchCriteria
      );
    }

  // STPs that have activity log entries (sorted by name, max 50 per call)
  getStpListForActivityLog(stpName?: string): Observable<ServerResponse> {
    let params = new HttpParams();
    if (stpName && stpName.trim()) {
      params = params.set('stpName', stpName.trim());
    }
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.activityLog.stpActivityLogStpList}`,
      { params }
    );
  }
}
